module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_9016.26312e15.png";